(function () {
  function initCategoryCarousel(section) {
    var track = section.querySelector('[data-cat-track]');
    var slides = section.querySelectorAll('[data-cat-slide]');
    var dots = section.querySelectorAll('[data-cat-dot]');
    if (!track || !slides.length) return;

    var ticking = false;

    function updateActive() {
      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var distance = Math.abs(trackCenter - slideCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }

        slide.classList.remove('is-active');
      });

      slides[closestIndex].classList.add('is-active');

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === closestIndex);
      });

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateActive);
        ticking = true;
      }
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateActive();
  }

  function initAll() {
    document.querySelectorAll('.section-category-showcase [data-mobile-carousel="true"]').forEach(initCategoryCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-mobile-carousel="true"]');
    if (section) initCategoryCarousel(section);
  });
})();